import dayjs from 'dayjs';
/* eslint-disable import/no-unassigned-import */
import 'dayjs/locale/en-ca';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/en-ie';
import 'dayjs/locale/en-au';
import 'dayjs/locale/fr-ca';
import 'dayjs/locale/es-us';
import 'dayjs/locale/es';
import 'dayjs/locale/ca';
import 'dayjs/locale/ja';
import 'dayjs/locale/fr';
/* eslint-enable import/no-unassigned-import */

const SHOP_HARDWARE_PREFIX = '/shop/hardware';

const getLocalePath = () => {
  return window.location.pathname.replace(SHOP_HARDWARE_PREFIX, '').slice(0, 6);
};

const getLanguageCode = () => getLocalePath().split('/')[2];

const getCountryCode = () => getLocalePath().split('/')[1];

const getLocaleString = () => {
  const countryCode = getCountryCode().toUpperCase();
  const langCode = getLanguageCode();

  return langCode === 'ja' ? 'ja' : `${langCode}-${countryCode}`;
};

const localizedShopPath = (version = 'v1') => {
  let versionPath = '';

  if (version?.toLowerCase() === 'v2') {
    versionPath = '/v2';
  }

  return `${SHOP_HARDWARE_PREFIX}${versionPath}${getLocalePath()}`;
};

const DAY_JS_LOCALES = [
  'ca',
  'en-ca',
  'en-gb',
  'en-ie',
  'en-au',
  'en',
  'es-us',
  'es',
  'fr-ca',
  'fr',
  'ja',
];

const localizedDayJs = (
  languageCode = getLanguageCode(),
  countryCode = getCountryCode(),
) => {
  let bestMatch;

  // First attempt to find a matching language + country code
  bestMatch = DAY_JS_LOCALES.find(
    (locale) =>
      locale === `${languageCode.toLowerCase()}-${countryCode.toLowerCase()}`,
  );

  // Then attempt to find a matching language
  bestMatch =
    bestMatch ||
    DAY_JS_LOCALES.find((locale) => locale === languageCode.toLowerCase());

  // If all else fails, default to 'en'
  bestMatch = bestMatch || 'en';

  dayjs.locale(bestMatch);

  return dayjs;
};

export {
  getLanguageCode,
  getCountryCode,
  getLocalePath,
  getLocaleString,
  localizedShopPath,
  localizedDayJs,
};
